<template>
  <plan-learn-more-dialog :visible.sync="visible" :planType="planType" />
</template>

<script>
import { ConfirmComponent } from '../common/service-dialog/confirm';
import { PLAN_LEARN_MORE_DIALOG as PlanLearnMoreDialog } from '@zoom/billing-shared';
import { planTypes } from '../../common/constants'

export default {
  name: 'VisitorManagementDialog',
  mixins: [ConfirmComponent],
  components: {
    PlanLearnMoreDialog,
  },
  data() {
    return {
      visible: false,
      planType: planTypes.VISITOR_MANAGEMENT,
    };
  },
};
</script>
